export const tableHeaders = [
  {
    id: 1,
    label: 'name',
    intlKey: 'table.name'
  },
  {
    id: 2,
    label: 'Fields included',
    intlKey: 'table.fields_included'
  },
  {
    id: 3,
    label: 'Recent updates',
    intlKey: 'table.recent_updates'
  },
  {
    id: 4,
    label: 'Action',
    intlKey: 'table.action'
  }
]
